import { Injectable } from '@angular/core'
import { first } from 'rxjs/operators'

declare let L: any

import { mapboxConfig } from '@app/core/constants/config-map'
import { MapCurrentLocationAdapter } from './map-current-location-adapter'
import { LatLng } from '@shared/models/latlng.model'
import { AbstractMapboxAdapter } from '@shared/services/abstract-mapbox-adapter'

@Injectable()
export class MapCurrentLocationMapboxService extends AbstractMapboxAdapter implements MapCurrentLocationAdapter {
  constructor() {
    super()
    this.loadMultipleExternalResources(mapboxConfig.mapboxLibrariesUrls)
      .pipe(first())
      .subscribe(() => this.setIsScriptLoaded(true))
  }

  setMarker(coordinate: LatLng) {
    const position = [coordinate.lat, coordinate.lng]
    L.marker(position).addTo(this.map)
  }
}
